// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m9Hj0ZHin7MsnkoP8IC0{flex-direction:column;gap:4px;display:flex}.m9Hj0ZHin7MsnkoP8IC0.TSiOHFfl8ovXyVXsG2Vc>:last-child{margin-bottom:32px}.m9Hj0ZHin7MsnkoP8IC0>:last-child{margin-bottom:24px}.DE3EtJ2veegaVnXfPsJZ{white-space:nowrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alertContainer": `m9Hj0ZHin7MsnkoP8IC0`,
	"emptyView": `TSiOHFfl8ovXyVXsG2Vc`,
	"tryAgain": `DE3EtJ2veegaVnXfPsJZ`
};
export default ___CSS_LOADER_EXPORT___;
